import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

type Result = ModelHookResult<
	{
		email: string;
		phone: string;
		emailHref: string;
	},
	undefined
>;

export function useContactDetails(): Result {
	const {
		featureConfigs: { dmProfileResponsivenessScoreConfig },
	} = useDecisionMakerProfilePageData();

	const emailHref = `mailto:${dmProfileResponsivenessScoreConfig.contact.email}`;

	return {
		data: {
			email: dmProfileResponsivenessScoreConfig.contact.email,
			phone: dmProfileResponsivenessScoreConfig.contact.phone,
			emailHref,
		},
	};
}
